var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('notifications',{attrs:{"id":"main-notifications","group":"main-notifications","position":"top right","animation-name":"v-fade-right"}})}
var staticRenderFns = []

export { render, staticRenderFns }